import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  generateQuestionRecommendation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/generative-ai/slide:generate-question`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const generateQuestionRecommendation = async ({ slideId }) => {
  const res = await resource.generateQuestionRecommendation({ slideId })
  return res.body
}

export default {
  initResource,

  generateQuestionRecommendation,
}
